import { render, staticRenderFns } from "./LanguageBlock.vue?vue&type=template&id=eac1c0dc&scoped=true&"
import script from "./LanguageBlock.vue?vue&type=script&lang=js&"
export * from "./LanguageBlock.vue?vue&type=script&lang=js&"
import style0 from "./LanguageBlock.vue?vue&type=style&index=0&id=eac1c0dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac1c0dc",
  null
  
)

export default component.exports